import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/system';

export const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  // Quando estiver em alternativeLabel (labels abaixo dos ícones):
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '1.5rem',                       
    left: 'calc(-50% + 1.5rem)',         
    right: 'calc(50% + 1.5rem)',       
  },

  // Estiliza sempre a linha, sem width fixa
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: '0.2rem',
    borderColor: '#e0e0e0',
    borderRadius: 1,
  },

  // Linha ativa
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderColor: '#2b97be',
  },
  // Linha completada
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderColor: '#2b97be',
  },
}));
